import { gql } from '@apollo/client'

export const ADD_MAGAZINE_ISSUE = gql`
    mutation addMagazineIssue($input: addEntityInput!) {
        addEntity(input: $input) {
            success
            entity {
                guid
                ... on MagazineIssue {
                    title
                    url
                }
            }
        }
    }
`

export const EDIT_MAGAZINE_ISSUE = gql`
    mutation editMagazineIssue($input: editEntityInput!) {
        editEntity(input: $input) {
            success
            entity {
                guid
                ... on MagazineIssue {
                    title
                    url
                    accessId
                }
            }
        }
    }
`
